import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {filter, map, mergeMap, withLatestFrom} from 'rxjs/operators';
import {VorlagenEntityTypes} from '../../../../client-constants';
import {getCurrentFunktionsbereichsId} from './aufgaben-berechtigungen-checklisten.selectors';
import {PageLoadDataAction} from './aufgaben-berechtigungen-checklisten.actions.ui';
import {Checkliste} from '../../../../clients/vorlagen';

@Injectable()
export class AufgabenBerechtigungenChecklistenPageWsEffects {
    wsUpdateListen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VorlagenEntityTypes.AUFGABE_ENTITY
                && x.message.entity_part.toUpperCase() === VorlagenEntityTypes.AUFGABE_ENTITY_PART_BENUTZER_BERECHTIGUNG;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Checkliste> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getCurrentFunktionsbereichsId)))
        , filter(([checkliste, fbId]) => {
            if (checkliste.funktionsbereich_id === fbId) {
                return true;
            }
            return false;
        })
        , mergeMap(([x, fbId]) =>
            [   new PageLoadDataAction(fbId)]
        )
    ));

    constructor(
        private actions$: Actions,
        private store: Store<any>,
    ) {
    }
}
